export const releaseNotesKeys = {
  all: ['release-notes'] as const,
};
